import { render, staticRenderFns } from "./loadingLogo.vue?vue&type=template&id=3b56abb4&scoped=true&"
var script = {}
import style0 from "./loadingLogo.vue?vue&type=style&index=0&id=3b56abb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56abb4",
  null
  
)

export default component.exports